var _path, _g, _g2, _path2, _g3, _g4, _path3, _g5, _g6, _g7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnergy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 109,
    viewBox: "0 0 108 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1909_1200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 4,
    width: 44,
    height: 31
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7441 4.77344H62.3373V34.581H19.7441V4.77344Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7457 4.77344C30.9469 4.77344 19.8037 11.0084 19.8037 20.3619C19.8037 28.1583 25.0276 27.1302 26.0387 34.3933C30.7144 26.599 38.5108 34.3933 47.8643 21.9212C53.1543 14.8671 52.9389 13.9286 61.8935 11.0084C61.8935 11.0084 58.7771 4.77344 44.7457 4.77344Z",
    fill: "#5F8C55"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5535 44.881C22.5522 37.4153 24.3632 28.4862 29.0602 22.2128C33.5866 16.1272 40.598 12.4434 47.8633 11.0078C44.3736 12.0957 41.0694 13.6998 38.1621 15.7966C29.7727 21.5025 25.1375 33.2195 29.6404 42.6114C31.4344 45.4356 27.0146 47.9057 25.5535 44.881Z",
    fill: "#AABC6E"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1909_1200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 77,
    y: 41,
    width: 26,
    height: 44
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0771 41.6797H102.422V84.819H77.0771V41.6797Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M91.5094 42.1875C86.8337 42.1875 85.2744 43.7468 80.5966 42.1875C83.7151 51.541 72.8023 51.541 79.0373 64.0131C82.847 71.6303 85.2744 78.0423 85.2744 84.2794C85.2744 84.2794 102.422 76.4852 102.422 59.3353C102.422 52.038 99.4593 42.1875 91.5094 42.1875Z",
    fill: "#5F8C55"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M70.2021 35.2286C86.7099 39.4883 96.6373 55.5567 89.9543 71.8065C90.9782 68.1589 91.3302 64.3386 90.8502 60.6591C89.6749 49.4988 79.8564 41.3611 69.1761 39.7912C66.0042 39.147 67.043 34.4543 70.2021 35.2286Z",
    fill: "#AABC6E"
  }))), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_1909_1200",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 71,
    width: 40,
    height: 31
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.77344 71.71H44.8641V101.424H5.77344V71.71Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.599 78.0426C19.8048 76.4854 14.1927 78.2623 7.33271 71.8076C7.33271 71.8076 5.77344 75.1757 5.77344 79.6019C5.77344 95.1925 19.8048 101.427 29.1583 101.427C41.6283 101.427 40.0711 96.7518 44.7468 92.0739C36.9526 87.3982 44.0621 81.3361 27.599 78.0426Z",
    fill: "#5F8C55"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M57.2831 87.5199C44.9496 98.8572 25.8864 96.402 15.125 84.2798C17.8916 86.8395 21.1467 88.7763 24.5766 90.1521C34.5637 94.5015 46.7841 92.3919 54.0322 84.1561C56.2869 81.8246 59.6977 85.3314 57.2831 87.5199Z",
    fill: "#AABC6E"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_d_1909_1200)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.2313 48.8801L67.672 47.3208C67.3798 47.0286 66.9851 46.8643 66.5713 46.8643H57.5378L61.8679 23.7674C62.0044 23.0358 61.6055 22.3084 60.9144 22.0332C60.2212 21.7538 59.4341 22.0055 59.0288 22.6305L38.7624 53.8096C38.3614 54.4261 38.4468 55.2409 38.9672 55.7614L40.5265 57.3185C40.8187 57.6108 41.2155 57.7771 41.6272 57.7771H50.6821L46.3285 82.4483C46.1983 83.1842 46.61 83.9094 47.3075 84.176C47.4889 84.2443 47.6787 84.2784 47.8621 84.2784C48.3911 84.2784 48.8988 84.0097 49.1889 83.5404L69.4552 50.802C69.8371 50.1877 69.7432 49.3899 69.2313 48.8801Z",
    fill: "#F5BB2D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1909_1200",
    x: 14.2888,
    y: 0.637265,
    width: 53.1196,
    height: 40.6499,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1909_1200",
    x: 18.5701,
    y: 6.87164,
    width: 34.8081,
    height: 46.2876,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1909_1200",
    x: 71.5623,
    y: 38.0513,
    width: 36.3745,
    height: 53.1216,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1909_1200",
    x: 61.738,
    y: 31.0064,
    width: 35.8384,
    height: 47.6939,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1909_1200",
    x: 0.258541,
    y: 67.6714,
    width: 50.0034,
    height: 40.646,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_d_1909_1200",
    x: 9.6101,
    y: 79.2505,
    width: 54.0161,
    height: 22.4692,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_d_1909_1200",
    x: 32.9958,
    y: 17.7837,
    width: 42.2085,
    height: 73.3882,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.37872
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.75745
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1909_1200"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1909_1200",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnergy);
export default __webpack_public_path__ + "static/media/energy.7a4e960a01cb99ecaf9210b0600701f1.svg";
export { ForwardRef as ReactComponent };